import React from "react";
import { formatGBP } from "../../lib/format";
import { Receipt } from "@phosphor-icons/react";

export default function OrderManagement({ orders, onRefundClick }) {
  return (
    <div className="space-y-2" data-testid="admin-order-management">
      {orders.map((o) => (
        <div key={o.order_id} className="card-surface p-4 flex items-center gap-4" data-testid="admin-order-row">
          <div className="flex-1 min-w-0">
            <p className="font-bold text-sm truncate">{o.vendor_name} — #{o.order_id.slice(-8)}</p>
            <p className="text-xs text-[#5C5C54]">{new Date(o.created_at).toLocaleString("en-GB")} · {formatGBP(o.total)}</p>
          </div>
          <span className="chip capitalize">{o.status}</span>
          {o.status !== "pending_payment" && o.status !== "cancelled" && (
            <button
              data-testid={`refund-btn-${o.order_id}`}
              onClick={() => onRefundClick(o.order_id)}
              className="btn-secondary text-xs gap-1 flex-shrink-0"
            >
              <Receipt size={14} weight="bold" /> Refund
            </button>
          )}
        </div>
      ))}
      {orders.length === 0 && (
        <p className="text-sm text-[#5C5C54] text-center py-8">No orders yet.</p>
      )}
    </div>
  );
}
